module.exports = __webpack_public_path__ + "static/media/facerecognition.48ed2f9c.png";